module.exports = __webpack_public_path__ + "4bae1919c290b401036664748d04e1d9.woff";